import { formatPhoneInput } from "../../utils/phoneFormat";

/**
 * Поле телефона: номер сам начинается с +7, пробелы и дефисы ставятся при вводе
 * (Чат 4, доработка №15, 04.11). [Claude] 2026-11-04
 * Backspace over a space or a dash removes the digit before it, so editing never gets stuck.
 */
export default function PhoneInput({ value, onChange, placeholder = "+7 900 000-00-00", ...rest }) {
    const handle = (event) => {
        const next = event.target.value;
        const prev = String(value ?? "");
        let formatted = formatPhoneInput(next);
        const digits = (s) => s.replace(/\D/g, "");
        if (next.length < prev.length && digits(next) === digits(prev) && digits(prev).length > 1) {
            formatted = formatPhoneInput(digits(prev).slice(0, -1));
        }
        if (formatted === "+7" && !digits(next).replace(/^[78]/, "") && next.length < prev.length) formatted = "";
        onChange?.(formatted);
    };
    return <input type="tel" inputMode="tel" autoComplete="tel" value={value ?? ""} onChange={handle} placeholder={placeholder} {...rest} />;
}
